export default function reducer(state, action) {
    if (action.type && action.type.endsWith("_REJECTED") &&
        action.payload && action.payload.response && [401, 408].includes(action.payload.response.status)) {
        window.location.replace("/login");
    }

    return null;
}